module.exports = __webpack_public_path__ + "static/media/tk.b5af863d.svg";